import { useMediaUrl } from './media';
import {
  chooseHeroMedia, type HeroMediaProps, type ResolvedHeroMedia,
} from './heroMediaChoice';
import type { EventDetail } from '../lib/catalog';

export { chooseHeroMedia };
export type { HeroMediaProps, ResolvedHeroMedia };

/**
 * Resolve the hero media for an event.
 *
 * ── REACT NEVER BUILDS A STORAGE URL ─────────────────────────────────────────────────
 *
 * Each asset id goes through the media service, which authorizes the request and returns
 * a public URL or a signed one. Nothing here knows a bucket exists.
 *
 * Every lookup is unconditional and in a fixed order; the choice is made between
 * already-fetched values, never by fetching conditionally. The decision itself is in
 * heroMediaChoice.ts, which has no imports and is tested directly.
 */
export function useHeroMedia(event: EventDetail, props: HeroMediaProps): ResolvedHeroMedia {
  const cmsVideo = useMediaUrl(props.videoMediaAssetId ?? null);
  const cmsPoster = useMediaUrl(props.posterMediaAssetId ?? null);
  const cmsImage = useMediaUrl(props.mediaAssetId ?? null);

  return chooseHeroMedia({
    cmsVideo,
    cmsPoster,
    cmsImage,
    legacyVideo: event.featuredVideoUrl ?? null,
    legacyWebm: event.featuredVideoWebmUrl ?? null,
    legacyImage: event.featuredImageUrl ?? null,
  });
}
